export default __webpack_public_path__ + "static/media/Connecting-With-and-Celebrating-Your-Culture.ba875c22.webp";